import React from 'react';
import { Info } from '@material-ui/icons';

export const MIconInfo = ({ style, color }) => <Info style={style} color={'primary'} />;
